// import React from 'react';
// import {BrowserRouter as Router, Route, Switch} from "react-router-dom"; 
// import FrontLayoutRoutes from "./frontend/frontRoutes"; 
// import {Confirmation} from "../components";
// const Home =  React.lazy(() => import('../container/frontend/home'));
// import { Switch, Route } from "react-router-dom";
// // const AboutUS =  React.lazy(() => import('../container/frontend/aboutUs'));

// function Routes() {
//   // var url = document.URL.split("/");
//   // //console.log("url ",url);
//   // if(url.length>3 && url[3]=="logout"){
//   //   localStorage.clear();
//   //   let domLink=url[0]+"//"+url[2];
//   //   //console.log('domLink ',domLink);
//   //   window.location.replace(domLink);
//   // }
//   return (
//     <Router>
//       <Switch>
//         <FrontLayoutRoutes exact path="/"  routeName={'home'} render={matchprops => (<Home {...matchprops} />)} />
//         {/* <FrontLayoutRoutes exact path="/about-us"  routeName={'aboutUs'} render={matchprops => (<AboutUS {...matchprops} />)} /> */}
//       </Switch>
//       <Confirmation/>
//     </Router>
//   )
//     ;
// }

// export default Routes;

import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; 
import FrontLayoutRoutes from "./frontend/frontRoutes"; 
import { Confirmation } from "../components";
import LoadingScreen from "../container/frontend/loadingScreen";

const Home = React.lazy(() => import('../container/frontend/home'));
const LegalPage = React.lazy(() => import('../container/frontend/legal'));

function AppRoutes() {
  return (
    <Router>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route 
            path="/" 
            element={
              <FrontLayoutRoutes>
                <Home />
              </FrontLayoutRoutes>
            } 
          />
          <Route
            path="/copyright"
            element={
              <FrontLayoutRoutes>
                <LegalPage page="copyright" />
              </FrontLayoutRoutes>
            }
          />
          <Route
            path="/disclaimer"
            element={
              <FrontLayoutRoutes>
                <LegalPage page="disclaimer" />
              </FrontLayoutRoutes>
            }
          />
          <Route
            path="/accessibility"
            element={
              <FrontLayoutRoutes>
                <LegalPage page="accessibility" />
              </FrontLayoutRoutes>
            }
          />
          <Route
            path="/policy"
            element={
              <FrontLayoutRoutes>
                <LegalPage page="policy" />
              </FrontLayoutRoutes>
            }
          />
        </Routes>
      </Suspense>

      <Confirmation />
    </Router>
  );
}

export default AppRoutes;